// Vue组件的错误上报
import { ErrorType, useSentry } from "~/composables/useSentry";

export default defineNuxtPlugin((nuxtApp) => {
  // 组合式 API 错误捕获
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    useSentry(err, ErrorType.Component, {
      component: instance?.$options.name,
      lifecycleHook: info,
    });
  };

  // 选项式 API 错误捕获
  nuxtApp.hook("vue:error", (err, instance, info) => {
    useSentry(err, ErrorType.Component, {
      component: instance?.$options.name,
      lifecycleHook: info,
    });
  });
});
